// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P9cw","comment":"styles_comment__2zLjh"};